if (!customElements.get('mix-cookie-sort')) {
  customElements.define('mix-cookie-sort', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[role="status"]');
      this.grid = document.getElementById('main-collection-product-grid');
      this.appliedSort = this.select.value;
      this.onChange = () => this.sort();
      this.onSubmit = (event) => { event.preventDefault(); this.sort(); };
      this.select.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.select?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit);
    }
    async sort() {
      this.controller?.abort();
      const controller = this.controller = new AbortController();
      const requestedSort = this.select.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', requestedSort);
      url.searchParams.delete('page');
      const requestUrl = new URL(url);
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.status.textContent = ((document.documentElement.lang || '').toLowerCase().split('-')[0] === 'nl' ? 'Cookies worden gesorteerd…' : 'Sorting cookies…');
      this.grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(requestUrl, { signal: controller.signal });
        if (!response.ok) throw new Error('Unable to load sorting');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller.signal.aborted) return;
        const sortedGrid = html.getElementById('main-collection-product-grid');
        if (!sortedGrid) throw new Error('Missing product grid');
        const orderedIds = Array.from(sortedGrid.querySelectorAll('[data-mix-card]'), card => card.id);
        const existing = new Map(Array.from(this.grid.querySelectorAll('[data-mix-card]'), card => [card.id, card.parentElement]));
        if (orderedIds.length !== existing.size || new Set(orderedIds).size !== existing.size || orderedIds.some(id => !existing.has(id))) {
          throw new Error('Product list changed');
        }
        // Move existing cards rather than replacing the builder or its selected items.
        orderedIds.forEach(id => this.grid.appendChild(existing.get(id)));
        this.appliedSort = requestedSort;
        history.replaceState(history.state, '', url);
        this.status.textContent = ((document.documentElement.lang || '').toLowerCase().split('-')[0] === 'nl' ? 'Cookies gesorteerd.' : 'Cookies sorted.');
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.select.value = this.appliedSort;
        this.status.textContent = ((document.documentElement.lang || '').toLowerCase().split('-')[0] === 'nl' ? 'De cookies konden niet worden gesorteerd. Probeer het opnieuw. Je selectie is ongewijzigd.' : 'Could not sort cookies. Please try again. Your selection is unchanged.');
      } finally {
        if (this.controller === controller) this.grid.removeAttribute('aria-busy');
      }
    }
  });
}
